"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldShowDiscount = void 0;
var Discount_service_1 = __importDefault(require("@CommonFrontendBackend/Discount/Discount.service"));
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var classnames_1 = __importDefault(require("classnames"));
var inversify_react_1 = require("inversify-react");
var es_toolkit_1 = require("es-toolkit");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var QuoteViewStore_1 = require("QuoteV2/Stores/QuoteViewStore");
var react_1 = __importStar(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var QuoteCurrencyFormatter_1 = __importDefault(require("Utils/QuoteCurrencyFormatter"));
var c = (0, BemBuilder_1.default)("discount-pill");
var shouldShowDiscount = function (discount, discountService) {
    var discountUnits;
    if (discount.isSavedType()) {
        var discountId = discount.id;
        if (discountId) {
            var savedDiscount = discountService.findDiscountById(discountId);
            if (savedDiscount) {
                discountUnits = savedDiscount.amount;
            }
        }
    }
    else {
        discountUnits = discount.units;
    }
    return discount.enabled && !(0, es_toolkit_1.isNil)(discountUnits) && discountUnits !== 0;
};
exports.shouldShowDiscount = shouldShowDiscount;
var DiscountPill = (function (_super) {
    __extends(DiscountPill, _super);
    function DiscountPill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DiscountPill.prototype, "savedDiscount", {
        get: function () {
            var discount = this.props.discount;
            if (discount.id) {
                var savedDiscount = this.discountService.findDiscountById(discount.id);
                if (savedDiscount) {
                    return savedDiscount;
                }
            }
            throw new Error("Unable to retrieve discount with id: ".concat(discount.id));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiscountPill.prototype, "discountUnits", {
        get: function () {
            var discount = this.props.discount;
            return discount.isSavedType() ? this.savedDiscount.amount : discount.units;
        },
        enumerable: false,
        configurable: true
    });
    DiscountPill.prototype.discountDetailText = function () {
        var discount = this.props.discount;
        var discountType = discount.isSavedType() ? this.savedDiscount.type : discount.type;
        if (!(0, es_toolkit_1.isNil)(this.discountUnits) && discountType) {
            if (discountType === Types_1.DiscountType.Percent) {
                return "".concat(this.discountUnits, "% ").concat(this.quoteViewStore.getLabel(Types_1.QuoteLabel.PercentageOff));
            }
            else {
                return "".concat(this.quoteCurrencyFormatter.formatWithUserDecimalPreference(this.discountUnits), " ").concat(this.quoteViewStore.getLabel(Types_1.QuoteLabel.PercentageOff));
            }
        }
    };
    DiscountPill.prototype.render = function () {
        var _a = this.props, discount = _a.discount, className = _a.className, _b = _a.showSavedDiscountName, showSavedDiscountName = _b === void 0 ? true : _b;
        if ((0, exports.shouldShowDiscount)(discount, this.discountService)) {
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)([c(), className, "user-font"]) },
                discount.isSavedType() && showSavedDiscountName && (react_1.default.createElement("span", { className: c("name") },
                    " ",
                    this.savedDiscount.name,
                    " ")),
                react_1.default.createElement("span", { className: c("details") }, this.discountDetailText())));
        }
        else {
            return null;
        }
    };
    var _a, _b, _c;
    __decorate([
        (0, inversify_react_1.resolve)("quoteCurrencyFormatter"),
        __metadata("design:type", typeof (_a = typeof QuoteCurrencyFormatter_1.default !== "undefined" && QuoteCurrencyFormatter_1.default) === "function" ? _a : Object)
    ], DiscountPill.prototype, "quoteCurrencyFormatter", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("discountService"),
        __metadata("design:type", typeof (_b = typeof Discount_service_1.default !== "undefined" && Discount_service_1.default) === "function" ? _b : Object)
    ], DiscountPill.prototype, "discountService", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteViewStore_1.QuoteViewStore.$),
        __metadata("design:type", typeof (_c = typeof QuoteViewStore_1.QuoteViewStore !== "undefined" && QuoteViewStore_1.QuoteViewStore) === "function" ? _c : Object)
    ], DiscountPill.prototype, "quoteViewStore", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], DiscountPill.prototype, "discountUnits", null);
    DiscountPill = __decorate([
        mobx_react_1.observer
    ], DiscountPill);
    return DiscountPill;
}(react_1.Component));
exports.default = DiscountPill;
